// extracted by mini-css-extract-plugin
export default {"auth-header":"AuthHeader_auth-header__C4C1E","auth-header__logo":"AuthHeader_auth-header__logo__jZ1FL"};